// extracted by mini-css-extract-plugin
export default {"select":"ServiceType_select__JlhYm"};